import VizWrapper from "@components/common/Base/VizWrapper";
import Button from "@components/common/Button";
import ImageRenderer from "@components/common/Image";
import Link from "@components/common/Link";
import Title from "@components/common/Title";
import OneAuthor from "@components/webinar/WebinarPoints/OneAuthor";
import { useWrapper } from "@context/wrapper";
import { FeaturedPodcastDynamicZoneModel } from "@models/strapi-components/feature-podcast";
import React from "react";

export interface FeaturedPodcastPropsModel {
  componentData: FeaturedPodcastDynamicZoneModel;
}

const FeaturedPodcast = ({ componentData }: FeaturedPodcastPropsModel) => {
  const { title, bgColor, subtitle, image, authors, points, ctaText, ctaLink } =
    componentData;

  const formattedPoints = points.split("\\n");

  const isBothCtaLinkAndTextAbsent = !ctaLink && !ctaText;

  const isCtaLinkToTop = ctaLink === "#";

  const { wrapperRef } = useWrapper();

  return (
    <VizWrapper
      style={{ backgroundColor: "#050505" }}
      className="pt-0 md:pt-[0px] xl:pt-0 "
    >
      {title && (
        <Title
          variant="h2"
          titleText={title}
          className="text-center mx-auto lg:ml-0 text-white"
        />
      )}
      <div
        className="p-8 rounded-2xl "
        style={{
          backgroundColor: bgColor ?? "#FFFFFF",
        }}
      >
        <div className="lg:grid grid-cols-4 gap-8 ">
          <div
            className="col-span-2 flex items-center mb-8 lg:mb-0"
            onClick={() => {
              if (ctaText && ctaLink) {
                window.open(ctaLink, "_blank");
              }
            }}
            style={{
              cursor: ctaText && ctaLink ? "pointer" : "default",
            }}
          >
            <ImageRenderer image={image} alt="Image" />
          </div>
          <div className="col-span-2">
            <div className="flex flex-col gap-2">
              <Title
                titleText={subtitle}
                variant="h3"
                className="text-primary-blue-50"
              />
              <ul>
                {formattedPoints.map((point, index) => {
                  return (
                    <li key={index} className="flex items-center">
                      <Title variant="paragraph" titleText={point} />
                    </li>
                  );
                })}
              </ul>
              <Title
                titleText="Speakers"
                variant="h3"
                className="text-primary-blue-50 mt-8"
              />
              <div className="flex flex-col lg:grid grid-cols-2 gap-x-4 gap-y-6 ">
                {authors.map((author) => (
                  <div key={author.id} className="">
                    <OneAuthor
                      data={{
                        author: author,
                        direction: 0,
                        variants: {},
                      }}
                    />
                  </div>
                ))}
              </div>
              <div>
                {!isBothCtaLinkAndTextAbsent && (
                  <Button
                    className="mt-6"
                    style={{ padding: 0, minHeight: "43px" }}
                    onClick={() => {
                      if (!isCtaLinkToTop) {
                        return;
                      }

                      wrapperRef?.current?.scroll({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                  >
                    {!isCtaLinkToTop ? (
                      <Link
                        href={ctaLink}
                        linkText={ctaText}
                        wrapperClassName="text-white"
                        className="text-white no-underline hover:font-normal px-10 flex items-center justify-center"
                        style={{ height: "43px" }}
                      />
                    ) : (
                      <span className="text-white no-underline hover:font-normal px-10 flex items-center justify-center">
                        {ctaText}
                      </span>
                    )}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </VizWrapper>
  );
};

export default FeaturedPodcast;
